import Material from "@primeng/themes/material";
import { definePreset } from "@primeng/themes";

const BqaTheme = definePreset(Material, {
  components: {
    checkbox: {
      colorScheme: {
        light: {
          checked: {
            background: "var(--gray-900)",
            borderColor: "var(--gray-900)",
            hoverBackground: "var(--gray-900)",
            hoverBorderColor: "var(--gray-900)",
            focusBorderColor: "var(--gray-900)"
          },
          icon: {
            checkedColor: "white",
            checkedHoverColor: "white"
          }
        }
      }
    },
    radiobutton: {
      colorScheme: {
        light: {
          checked: {
            background: "var(--gray-900)",
            borderColor: "var(--gray-900)",
            hoverBackground: "var(--gray-700)",
            hoverBorderColor: "var(--gray-700)",
            focusBorderColor: "var(--gray-900)"
          },
          icon: {
            checkedColor: "white",
            checkedHoverColor: "white"
          }
        }
      }
    },
    tag: {
      colorScheme: {
        light: {
          success: {
            background: "var(--success-100)",
            color: "var(--success-800)"
          },
          warn: {
            background: "var(--yellow-100)",
            color: "var(--yellow-900)"
          },
          info: {
            background: "var(--blue-100)",
            color: "var(--blue-900)"
          },
          danger: {
            background: "var(--danger-100)",
            color: "var(--danger-900)"
          }
        }
      }
    },
    message: {
      colorScheme: {
        light: {
          success: {
            background: "var(--success-100)",
            color: "var(--success-800)"
          },
          warn: {
            background: "var(--yellow-100)",
            color: "var(--yellow-900)"
          },
          info: {
            background: "var(--blue-100)",
            color: "var(--blue-900)"
          },
          danger: {
            background: "var(--danger-100)",
            color: "var(--danger-900)"
          }
        }
      }
    },
    badge: {
      colorScheme: {
        light: {
          danger: {
            background: "var(--danger-500)",
            color: "#fff"
          }
        }
      }
    },
    tabs: {
      colorScheme: {
        light: {
          tab: {
            color: "var(--gray-500)",
            activeColor: "var(--gray-900)",
            activeBorderColor: "var(--gray-900)",
            hoverColor: "var(--gray-900)"
          },
          tablist: {
            background: "transparent",
            borderColor: "var(--gray-200)"
          },
          tabpanel: {
            background: "transparent"
          }
        }
      }
    }
  }
});

export default BqaTheme;